import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 800px;
  padding: 32px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  margin-bottom: 40px;

  .main-title {
    font-size: 24px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 32px;
    border-bottom: 2px solid #f3f4f6;
    padding-bottom: 16px;
  }

  .rule-section {
    margin-bottom: 28px;

    h2 {
      font-size: 18px;
      font-weight: 600;
      color: #1f2937;
      margin-bottom: 12px;
    }

    p {
      font-size: 14px;
      line-height: 1.6;
      color: #4b5563;
      margin-bottom: 10px;
    }

    ul {
      margin: 10px 0 14px 24px;
      padding: 0;

      li {
        font-size: 14px;
        line-height: 1.6;
        color: #4b5563;
        margin-bottom: 6px;
      }
    }

    a {
      color: #2563eb;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
